jQuery(document).ready(function($){

    $(document).on("click", ".fast-access__link-cart", function(event) { 
        event.preventDefault();
        if ($('body').hasClass('woocommerce-checkout') || $('body').hasClass('woocommerce-cart')) {
            return;
        }
        $(this).next('.fast-access__widget-cart').toggleClass('fast-access__widget-cart--active');
        $('#masthead').toggleClass('myf-overlay');
    });

    $(document).on("click", ".fast-access__widget-cart__close, #masthead.myf-overlay, .__MyfContinued", function(event) {        
        if (!$(event.target).closest('.fast-access__widget-cart').length 
        || event.target.classList.contains('fast-access__widget-cart__close')
        || event.target.classList.contains('__MyfContinued')) {
            $('.fast-access__widget-cart').removeClass('fast-access__widget-cart--active');
            $('#masthead').removeClass('myf-overlay');
        }
    });

    //Cart header
    jQuery(document).on('change', '.woocommerce.widget_shopping_cart input.qty', function(){
        var value = $(this).val();
        var headerCartAmount = $('.__header-cart__amount').find('span');
        var headerCartCount = $('.__header-cart__count');
        if (!isNaN(value) && value > 0) {
            var item = $(this).closest('li');
            if (item.length) {
                var removeButton = $(item).find('.remove_from_cart_button');
                if (removeButton.length) {
                    var itemHash = removeButton.attr('data-cart_item_key');
                    if (itemHash) {

                        item.block({
                            message: null,
                            overlayCSS: {
                                opacity: 0.3
                            }
                        });

                        $.ajax({
                            type: 'POST',
                            dataType: 'json',
                            url: frontendajax.ajaxurl,
                            data: {
                                action: 'change_widget_cart_qty',
                                hash: itemHash,
                                quantity: value,
                            },
                            success: function(response) {
                                if (response.success && response.data.subtotal_html) {
                                    var miniCart = $(item).closest('div.widget_shopping_cart_content');
                                    var itemQty = $(item).find('.woocommerce-mini-cart-item-qty');
                                    if (miniCart.length) {
                                        var subTotal = $(miniCart).find('.woocommerce-mini-cart__total .woocommerce-Price-amount.amount');
                                        if (subTotal) {
                                            subTotal.replaceWith(response.data.subtotal_html);
                                            headerCartAmount.replaceWith(response.data.subtotal_html);
                                            headerCartCount.html(response.data.subtotal_qty);
                                            itemQty.html(response.data.qty);
                                        }
                                    }
                                    $(item).find('input.qty').val(response.data.qty);
                                }

                                // Recharger tous les fragments WooCommerce pour refléter
                                // les prix remisés dynamiques (Discount Rules, coupons, etc.).
                                $(document.body).trigger('wc_fragment_refresh');

                                // Si on est sur panier/checkout, forcer aussi le refresh des totaux.
                                $('body').trigger('update_checkout');
                                $('body').trigger('updated_wc_div');
                            },
                            complete: function() {
                                item.css( 'opacity', '1' ).unblock();
                            },
                        });
                    }
                }

            }
        }
    });


    // Lorsqu'un champ de conditionnement change
    jQuery(document).on('change', '.pa_conditionnement', function(){
        // Récupérer le nouveau conditionnement sélectionné
        var newConditionnement = $(this).val();
        var cartItemKey = $(this).data('cart-item-key');

        var item = $(this).closest('li');
        item.block({
            message: null,
            overlayCSS: {
                opacity: 0.3
            }
        });

        // Envoyer la mise à jour via AJAX
        $.ajax({
            url: frontendajax.ajaxurl,
            type: 'POST',
            data: {
                action: 'update_cart_item_conditionnement',
                cart_item_key: cartItemKey,
                pa_conditionnement: newConditionnement,
            },
            success: function(response) {
                // Si la mise à jour est réussie, recharger la mini-cart pour refléter les changements
                $(document.body).trigger('wc_fragment_refresh');
            },
            error: function() {
                alert('Une erreur est survenue lors de la mise à jour du conditionnement.');
            },
            complete: function() {
                item.css( 'opacity', '1' ).unblock();
            },
        });
    });

    
    jQuery(function($) {
        // Événement AJAX "AJAX ajouter au panier" WooCommerce
        $(document.body).on('added_to_cart', function() {
            // Afficher la sidebar
            $('.fast-access__widget-cart').addClass('fast-access__widget-cart--active');
            $('#masthead').addClass('myf-overlay');
        });
    });
});